import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";

export interface FullPageMessageProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  /** `fullscreen` — whole viewport (e.g. /offline). `embedded` — inside Layout scroll area. */
  variant?: "fullscreen" | "embedded";
}

/** Full-screen or in-page centered message. */
export function FullPageMessage({
  icon: Icon,
  title,
  subtitle,
  action,
  variant = "fullscreen",
}: FullPageMessageProps) {
  return (
    <div
      className={
        variant === "embedded"
          ? "flex min-h-[50vh] flex-1 flex-col items-center justify-center gap-4 bg-background px-6 py-12 text-center"
          : "flex min-h-dvh flex-col items-center justify-center gap-4 bg-background p-6 text-center"
      }
    >
      {/* ux-consistency: loading/empty C */}
      <div className="rounded-full bg-muted p-6 text-muted-foreground">
        <Icon className="h-16 w-16" aria-hidden />
      </div>
      <div className="max-w-md space-y-2">
        <h1 className="text-2xl font-bold text-foreground">{title}</h1>
        {subtitle ? <p className="text-muted-foreground">{subtitle}</p> : null}
      </div>
      {action ? <div className="w-full max-w-md">{action}</div> : null}
    </div>
  );
}
